/**
 * Актуальні ціни для відображення та оплати.
 * PRICE_UAH = PRICE_USD * 43 (курс константа для збігу з сервером/LiqPay).
 */
export const PRICE_USD = 4
/** Ціна в гривнях за курсом 43 грн/USD */
export const PRICE_UAH = 172
